import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { InstitutionInfo } from '../models/institution-info.model';
import { InstitutionInfoEndpoint } from './institution-info-endpoint.service';
import { ErrorHandleService } from './error-handle.service';
import { AlertService, MessageSeverity } from './alert.service';

@Injectable({
  providedIn: 'root'
})

export class InstitutionInfoService {

  constructor(private alertService: AlertService, private institutionInfoEndpoint: InstitutionInfoEndpoint,
    private errorHandleService: ErrorHandleService) { }

  getInstitutionInfo(id: number): Observable<InstitutionInfo> {
    const result: InstitutionInfo = new InstitutionInfo();

    this.institutionInfoEndpoint.getInstitutionInfoEndpoint<InstitutionInfo>(id)
      .subscribe(respose => {
        result.update(respose);
      }, error => this.errorHandleService.showMessageAndRedirect("データ取得失敗", "空床情報取得中にエラーが発生しました。", error));

    return of(result);
  }

  updateInstitutionInfo(institutionInfo: InstitutionInfo): Observable<InstitutionInfo> {
    const result: InstitutionInfo = new InstitutionInfo();

    this.alertService.startUpdatingMessage();
    this.institutionInfoEndpoint.updateInstitutionInfoEndpoint<InstitutionInfo>(institutionInfo)
      .subscribe(respose => {
        this.alertService.stopUpdatingMessage();
        result.update(respose);
        this.alertService.showStickyMessage("データ更新成功", "空床情報を更新しました。", MessageSeverity.success);
      }, error => {
        this.alertService.stopUpdatingMessage();
        this.errorHandleService.showMessageAndRedirect("データ更新失敗", "空床情報更新中にエラーが発生しました。", error);
      });

    return of(result);
  }
}
